import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

@Component({
  selector: 'page-product_details',
  templateUrl: 'product_details.html'
})
export class Product_detailsPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/product_details/product_details.ts